import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    content: {
      paddingLeft: '10px',
      paddingRight: '10px',
      paddingBottom: '10px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    lotsList: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      '@media (max-width: 950px)': {
        justifyContent: 'flex-start',
        gap: '10px',
        overflow: 'scroll',
        flexWrap: 'nowrap'
      }
    },
    labelsList: {
      display: 'flex',
      flexDirection: 'column'
    },
    buttonsList: {
      display: 'flex',
      gap: '10px',
      '@media (max-width: 724px)': {
        flexDirection: 'column'
      }
    },
    desc: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      '@media (max-width: 724px)': {
        flexDirection: 'column',
        gap: '15px',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap'
      }
    },
    note: {
      fontSize: '1rem',
      color: palette.text.primary,
      marginTop: '5px',
      '@media (max-width: 724px)': {
        marginTop: '15px'
      }
    },
    reglementLink: {
      color: 'inherit'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
